import { AddSearchCriteria } from "apps/console/modules/program/configuration/selection/fsl/detail/components/searchCriteria";
import Icon from "assets/icons";
import { useFormikContext } from "formik";
import React from "react";
import { useGetApiData } from "shared/datalayer";
import { ApiUrlType } from "shared/datalayer/type";
import FormCheckboxField from "shared/form/fields/checkboxField";
import FormLabel from "shared/form/fields/formLabel";
import { useCopies } from "shared/hooks/useCopies";
import I18n from "shared/types/I18n";
import { ApiContextCriteriaField } from "shared/types/contact/ApiContextCriteriaField";

export default function AddLicenseOrAdminCriteria(props: {
  name: string;
  eventId?: string;
  api: ApiUrlType;
  label: keyof I18n;
  infoLabel: keyof I18n;
  disabled: boolean;
  isOptional: boolean;
  children: any;
  warningMessage?: string;
}) {
  const { values, setFieldValue } = useFormikContext<any>();
  const { data } = useGetApiData<ApiContextCriteriaField>(
    props.api,
    {
      params: {
        eventId: props.eventId
      }
    },
    { enabled: Boolean(props.eventId) }
  );
  React.useEffect(() => {
    return () => {
      setFieldValue(props.name, null);
    };
  }, [props.name, setFieldValue]);

  const copies = useCopies();
  if (!data) return null;

  const checkboxFieldName = `${props.name}_enabled`;

  return (
    <div className="accessCriteria consoleSelectionList_card">
      <div className="consoleSelectionList_card_head">
        {props.isOptional ? (
          <div className="form_item" style={{ display: "flex", justifyContent: "space-between" }}>
            <FormCheckboxField
              disabled={props.disabled}
              name={checkboxFieldName}
              label={copies.get(props.label)}
              infoLabel={copies.get(props.infoLabel)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (!e.target.checked) {
                  setFieldValue(props.name, null);
                }
              }}
            />
            {props.warningMessage && (
              <div className="iconMessage_warning">
                <Icon.InfoCircle />
                {props.warningMessage}
              </div>
            )}
          </div>
        ) : (
          <FormLabel label={copies.get(props.label)} required></FormLabel>
        )}
      </div>
      <div className="consoleSelectionList_card_body">
        {values[checkboxFieldName] && (
          <AddSearchCriteria
            hasGroupAction={true}
            className="accessCriteria_ruleGroup"
            disabled={props.disabled}
            name={props.name}
            searchCriteriaConfigFieldOptions={data as any}
          />
        )}
        {values[checkboxFieldName] && props.children}
      </div>
    </div>
  );
}
